import React from 'react';
import useFilterStore from '../../zustandStore/useFilterStore';
import RpRangeAutocomplete from 'components/commons/RpRangeAutocomplete';
import SearchFilterUtil from 'lib/SearchFilterUtil';
import PropTypes from 'prop-types';

const RangeAutocomplete = React.memo(function RangeAutocomplete(props) {
    const filters = useFilterStore(state => state.filters[props.comparableType]?.[props.attrName]);
    const setFilters = useFilterStore(state => state.setFilters);
    const errors = useFilterStore(state => state.errors[props.comparableType]);
    const setError = useFilterStore(state => state.setError);
    const removeError = useFilterStore(state => state.removeError);
    const minOptions = props.minOptions;
    const maxOptions = props.maxOptions;

    const minValue = filters?.min ? SearchFilterUtil.findOptionByValue(minOptions, filters.min) : { value: '', label: 'Min' };
    const maxValue = filters?.max ? SearchFilterUtil.findOptionByValue(maxOptions, filters.max) : { value: '', label: 'Max' };

    const onError = (error) => {
        if (Boolean(error.length)) {
            setError(props.comparableType, props.attrName);
        } else {
            removeError(props.comparableType, props.attrName);
        }
    };

    return (
        <RpRangeAutocomplete
            label={props.label}
            active={minValue.value !== '' || maxValue.value !== ''}
            error={errors.includes(props.attrName)}
            subLabel={props.subLabel}
            minOptions={minOptions}
            maxOptions={maxOptions}
            minValue={minValue}
            maxValue={maxValue}
            formatter={props.formatter}
            onChange={({ min, max }) => setFilters(props.comparableType, { [props.attrName]: { min: min.value, max: max.value } })}
            validateInput={props.validateInput}
            isDropdown={props.isDropdown}
            onError={onError}
            value={props.valueFormatter ? props.valueFormatter(minValue.value, maxValue.value) : null}
            maxInputLength={props.maxInputLength}
            dropdownDisplayFormatter={props.dropdownDisplayFormatter}
            showValueAsTooltip={props.showValueAsTooltip}
        />
    );
});

RangeAutocomplete.propTypes = {
    comparableType: PropTypes.string.isRequired,
    attrName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
    minOptions: PropTypes.array.isRequired,
    maxOptions: PropTypes.array.isRequired,
    formatter: PropTypes.func,
    validateInput: PropTypes.func,
    valueFormatter: PropTypes.func,
    isDropdown: PropTypes.bool,
    showValueAsTooltip: PropTypes.bool,
};

export default RangeAutocomplete;
